/* src/app/modules/coils/components/coils/coils.component.scss */
.coil-card {
  margin-bottom: 10px;
}
.fit-width {
  min-width: 15pc;
}
#coilDropDown {
  width: fit-content;
}
.coilCalendar {
  align-self: center;
}
.local-coil {
  align-items: center;
  margin-bottom: 1rem;
}
span {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 0.5rem;
}
sh-icon {
  margin-left: 0.5rem;
}
.error-icon {
  display: inline-block;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.coil-detail-container {
  columns: 2 auto;
}
.error {
  scale: 0.8;
  opacity: 0.7;
  gap: 0.5rem;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.error h3 {
  margin: 0rem;
}
.error sh-icon {
  filter: grayscale(1);
}
.back-to-system-overview {
  display: initial;
  justify-content: center;
  display: flex;
}
app-no-data-icon {
  display: contents;
}
[screen-tablet] :host-context .coil-detail-container,
[screen-phone] :host-context .coil-detail-container {
  columns: 1;
}
/*# sourceMappingURL=coils.component.css.map */
